import { Theme } from "@mui/material/styles/createTheme";
import { SxProps } from "@mui/system/styleFunctionSx";

export const sxProps: Record<string, SxProps<Theme>> = {
  wrapperBox: {
    flex: 1,
    paddingBottom: (theme) => theme.spacing(2),
  },
};
